import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
	providedIn: "root"
})
export class PofStateService {
	private filesList$: BehaviorSubject<File[]> = new BehaviorSubject<File[]>([]);

	public getState$(): Observable<File[]> {
		return this.filesList$.asObservable();
	}

	public updateState(state: File[]): void {
		this.filesList$.next([...state]);
	}
}
